import { Accordion, Button, getValidIcon, Icon } from 'components/ui'
import { useIsMobile } from 'lib/hooks/useIsMobile'
import { BusinessAnnouncementStoryblok } from 'lib/storyblok/types'
import { getAnchorFromCmsLink } from 'lib/utils/content'

type BusinessAnnouncementProps = {
  block: BusinessAnnouncementStoryblok
}

export const BusinessAnnouncement = ({ block }: BusinessAnnouncementProps) => {
  const { icon, title, description, cta } = block
  const typedIcon = getValidIcon(icon)
  const { rel, href, target } = getAnchorFromCmsLink(
    cta?.length === 0 ? undefined : cta?.[0].link
  )

  const isMobileDevice = useIsMobile()

  return !description && (!cta || cta.length === 0) ? (
    <div className="flex items-center justify-center gap-1.5 px-3 lg:px-5 py-3 rounded-b-3 lg:rounded-b-5 bg-background-secondary-news-light">
      <Icon
        icon={typedIcon ?? 'message-bubble'}
        size={isMobileDevice ? 18 : 20}
        className="text-foreground/60"
        aria-hidden="true"
      />
      <span className="text-fourteen lg:text-eighteen font-regular">
        {title}
      </span>
    </div>
  ) : (
    <Accordion
      items={[
        {
          title: title,
          content: (
            <div className="flex flex-col gap-4 lg:gap-5">
              <p>{description}</p>
              {cta && (
                <Button
                  as="a"
                  variant="tertiary"
                  rel={rel}
                  href={href}
                  target={target}
                  size="sm"
                >
                  {cta[0].label}
                </Button>
              )}
            </div>
          ),
        },
      ]}
      titleIcon={typedIcon}
      variant="announcement"
    />
  )
}
